import { jsx, jsxs } from "react/jsx-runtime";
import { format } from "date-fns/format";
import { motion } from "motion/react";
import { Absolute, Box, Flex, Text } from "pcln-design-system";
import { useCallback, useState } from "react";
import styled_components from "styled-components";
import VoteDown from "../../Assets/VoteDown.js";
import VoteUp from "../../Assets/VoteUp.js";
import { VoteType } from "../../chatTypes.js";
import { useMessageFeedback } from "../../hooks/useMessageFeedback.js";
const VoteWrapper = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "MessageFooterWithVote__VoteWrapper"
})([
    "cursor:pointer;"
]);
const MessageFooterWithVote = ({ footerMessagePrefix, isNotUser, isGreetingMessage, isMobile = false, message })=>{
    const { vote = VoteType.NONE, date } = message;
    const [voteStatus, setVoteStatus] = useState(vote);
    const { submitFeedback } = useMessageFeedback(message);
    const transformedDate = date ? new Date(date).valueOf() : void 0;
    const footerMessageDateString = transformedDate && 'number' == typeof transformedDate ? format(date, "LLL d 'at' h:mm:ss aaa") : '';
    const handleVoteStatus = useCallback((status)=>{
        setVoteStatus(status);
    }, []);
    const showVoteUp = voteStatus === VoteType.NONE || voteStatus === VoteType.UP;
    const showVoteDown = voteStatus === VoteType.NONE || voteStatus === VoteType.DOWN;
    const voteGap = isMobile ? 4 : 3;
    if (!footerMessageDateString) return null;
    return /*#__PURE__*/ jsx(motion.div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        children: /*#__PURE__*/ jsxs(Flex, {
            alignItems: "center",
            justifyContent: isNotUser ? 'space-between' : 'flex-end',
            children: [
                footerMessagePrefix && /*#__PURE__*/ jsx(Absolute, {
                    width: 0.96,
                    top: "-10px",
                    children: /*#__PURE__*/ jsxs(Flex, {
                        justifyContent: 'space-between',
                        width: 1,
                        children: [
                            /*#__PURE__*/ jsxs(Text, {
                                color: "text.light",
                                textStyle: "subheading6",
                                children: [
                                    footerMessagePrefix,
                                    " \xb7 ",
                                    footerMessageDateString
                                ]
                            }),
                            isGreetingMessage ? null : /*#__PURE__*/ jsxs(Flex, {
                                children: [
                                    showVoteUp ? /*#__PURE__*/ jsx(VoteWrapper, {
                                        "data-testid": "vote-up-button",
                                        mr: showVoteUp && !showVoteDown ? 0 : voteGap,
                                        onClick: async function() {
                                            handleVoteStatus(VoteType.UP);
                                            await submitFeedback(VoteType.UP, '');
                                        },
                                        children: /*#__PURE__*/ jsx(VoteUp, {
                                            isActive: voteStatus === VoteType.UP
                                        })
                                    }) : null,
                                    showVoteDown ? /*#__PURE__*/ jsx(VoteWrapper, {
                                        "data-testid": "vote-down-button",
                                        onClick: async function() {
                                            handleVoteStatus(VoteType.DOWN);
                                            await submitFeedback(VoteType.DOWN, '');
                                        },
                                        children: /*#__PURE__*/ jsx(VoteDown, {
                                            isActive: voteStatus === VoteType.DOWN
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                }),
                !footerMessagePrefix && /*#__PURE__*/ jsx(Text, {
                    color: "text.light",
                    textStyle: "subheading6",
                    children: footerMessageDateString
                })
            ]
        })
    });
};
export { MessageFooterWithVote };
